<div class="product-carousel-container">
  <div class="content">
    <div class="image-nav">
      <kion-preview-image *ngFor="let image of carouselImages, let i = index" [image]="image" [selected]="i === this.activeSlide" (click)="updateSlide(i)"></kion-preview-image>
    </div>
    <div class="carousel">
      <kion-product-image-carousel
        [items]="carouselItems"
        [activeSlide]="activeSlide"
        (update)="updateSlide($event)"
      ></kion-product-image-carousel>
    </div>
  </div>
</div>
